<template>
  <div id="pdfvuer">
    <Pdf :src="pdfdata" v-for="i in numPages" :key="i" :id="i" :page="i"
      :scale.sync="scale">
      <!-- <template slot="loading" style="text-align:center">
        loading content here...
      </template> -->
    </Pdf>
  </div>
</template>

<script>
import pdfvuer from 'pdfvuer'
import {IsPC} from '../../utils/index'
export default {
  props:['url'],
  components: {
    Pdf: pdfvuer
  },
  data () {
    return {
      page: 1,
      numPages: 0,
      pdfdata: '',
      errors: [],
      scale: 'page-width',
      isShowPdf: true
    }
  },
  mounted () {
    if(this.url){
      this.getPdf();
    }
  },
  watch: {
    show: function (s) {
      if(s) {
        this.getPdf();
      }
    },
    page: function (p) {
      if( window.pageYOffset <= this.findPos(document.getElementById(p)) || ( document.getElementById(p+1) && window.pageYOffset >= this.findPos(document.getElementById(p+1)) )) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView();
      }
    }
  },
  methods: {
    getPdf () {
      this.$toast.loading({
        // mask: true,
        forbidClick: true,
        message: 'loading...',
        duration: 0
      })
      var self = this;
      self.pdfdata = pdfvuer.createLoadingTask(self.url);
      self.pdfdata.then(pdf => {
        self.numPages = pdf.numPages;
        this.$toast.clear();
        window.onscroll = function() { 
          // changePage() 
          // stickyNav()  
        }

        // Get the offset position of the navbar
        // var sticky = $('#buttons')[0].offsetTop

        // Add the sticky class to the self.$refs.nav when you reach its scroll position. Remove "sticky" when you leave the scroll position
        // function stickyNav() {
        //   if (window.pageYOffset >= sticky) {
        //     $('#buttons')[0].classList.remove("hidden")
        //   } else {
        //     $('#buttons')[0].classList.add("hidden")
        //   }
        // }

        function changePage () {
          var i = 1, count = Number(pdf.numPages);
          do {
            if(window.pageYOffset >= self.findPos(document.getElementById(i)) && 
                window.pageYOffset <= self.findPos(document.getElementById(i+1))) {
              self.page = i
            }
            i++
          } while ( i < count)
          if (window.pageYOffset >= self.findPos(document.getElementById(i))) {
            self.page = i
          }
        }
      }).catch(()=>{
        this.$toast.clear();
      });
    },
    findPos(obj) {
      // return obj.offsetTop;
    }
  },
  beforeDestroy() {
    // this.url = '';
    console.log('销毁了')
  },
}
</script>

<style lang="css" scoped>
  #buttons {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  #pdfvuer>div{
    margin: 3px 0!important;
  }
  /* Page content */
  .content {
    padding: 16px;
  }
</style>


// WEBPACK FOOTER //
// src/components/pdf/index.vue